import React from 'react';
import AboutPage from './AboutPage'; // Import the AboutPage component
import About from './About';
import CertificatesBadgesSection from './CertificatesBadgesSection';
import SongCarousel from './SongCarousel';




export default function MainAbout() {
  return (
    <div className="min-h-screen relative bg-black ">
      <About/>
      <div className="max-w-7xl mx-auto">
        
        
        <AboutPage />
      </div>
<CertificatesBadgesSection/>

    </div>
  );
}
